import { Route, Routes, Outlet } from "react-router-dom";
import ChangePasswordScreen from "../screens/Authentication/ChangePasswordScreen";
import ResetPasswordScreen from "../screens/Authentication/ResetPasswordScreen";
import VerifyPhoneEmailScreen from "../screens/Authentication/VerifyPhoneEmailScreen";
import HomeDashboardScreen from "../screens/AdminDashboard";
import LoginScreen from "../screens/Authentication/Admin/LoginScreen";
import MFAVerifyScreen from "../screens/Authentication/Admin/MFAVerifyScreen";
import WorkspaceScreen from "../screens/Authentication/WorkspaceScreen";

const routes = [
  {
    path: "/admin-login",
    element: <LoginScreen />,
  },
  {
    // BTD staff have their own door too, so the URL says which kind of
    // login is in progress. /admin-login is kept working for existing
    // bookmarks but is no longer a door of its own - it is treated as this
    // one, and anybody arriving there is checked like any other BTD login.
    path: "/btd-login",
    element: <LoginScreen />,
  },
  {
    path: "/btd-login/mfa/:token",
    element: <MFAVerifyScreen />,
  },
  {
    // Same screen, different door. The path is what tells the login which
    // kind of staff is at it, so each can be refused for the right reason
    // rather than everyone landing in the same place and finding out later.
    path: "/facility-login",
    element: <LoginScreen />,
  },
  {
    path: "/facility-login/mfa/:token",
    element: <MFAVerifyScreen />,
  },
  {
    path: "/admin-login/mfa/:token",
    element: <MFAVerifyScreen />,
  },
  {
    path: "/forgot-password",
    element: <ChangePasswordScreen />,
  },
  {
    path: "/forgot-password/:type",
    element: <ChangePasswordScreen />,
  },
  {
    path: "/forgot-password/:type/:email",
    element: <ChangePasswordScreen />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordScreen />,
  },
  {
    path: "/reset-password/:type/:token",
    element: <ResetPasswordScreen />,
  },
  {
    path: "/verify_phone_email",
    element: <VerifyPhoneEmailScreen />,
  },
  {
    path: "/workspace",
    element: <WorkspaceScreen />,
  },
  {
    path: "/dashboard/*",
    element: <HomeDashboardScreen />,
  },
];

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
        <Route path="*" element={null} />
      </Routes>
      <Outlet />
    </>
  );
};
